import { render, staticRenderFns } from "./CytomineModalCard.vue?vue&type=template&id=2b28ea0d"
import script from "./CytomineModalCard.vue?vue&type=script&lang=js"
export * from "./CytomineModalCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports